import { useEffect, useRef, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { useReducedMotion } from '@/lib/useReducedMotion';

/** Scroll updates stay here so long catalogues do not rerender on every wheel event. */
export const ScrollControls = () => {
  const reduced = useReducedMotion();
  const progressRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raf = 0;
    const paint = () => {
      raf = 0;
      const range = document.documentElement.scrollHeight - window.innerHeight;
      const progress = range > 0 ? Math.max(0, Math.min(window.scrollY / range, 1)) : 0;
      if (progressRef.current) progressRef.current.style.transform = `scaleX(${progress})`;
      setVisible(window.scrollY > 400);
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(paint); };
    const observer = new ResizeObserver(schedule);
    observer.observe(document.documentElement);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    paint();
    return () => {
      if (raf) cancelAnimationFrame(raf);
      observer.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    };
  }, []);

  return <>
    <div className="fixed top-0 left-0 right-0 z-50 h-[3px] pointer-events-none" aria-hidden="true">
      <div ref={progressRef} className="h-full bg-gradient-to-l from-primary via-accent to-secondary" style={{ transform: 'scaleX(0)', transformOrigin: 'left' }} />
    </div>
    <button
      onClick={() => { window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); document.getElementById('main-content')?.focus({ preventScroll: true }); }}
      aria-label="חזרה לראש העמוד"
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
      className={`fixed bottom-20 left-4 z-40 w-11 h-11 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center transition-[opacity,transform] duration-500 hover:bg-primary/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
    ><ArrowUp className="w-4 h-4 text-primary" aria-hidden="true" /></button>
  </>;
};
